export enum PerDizzleFeatureFlags {
    SeamlessRebooking = 'seamless-rebooking',
    DisableNovaConfirmStatus = 'disable-nova-confirmed-shift-status',
    EnableFillableShiftsPage = 'enable-nova-fillable-shifts-page',
    RenameReconfirmedStatusNova = 'rename-reconfirmed-status-nova',
    EnableFillableShiftsTwoWeekView = 'fillable-shifts-two-week-view',
    RenameReconfirmedStatusShiftHistoryAndNotificationsNova = 'rename-reconfirmed-status-history-and-notifications-nova',
    EnableFillableShiftsSourceFilter = 'enable-fillable-shifts-source-filter',
    EnableShiftManagementSidePanelFilters = 'enable-shift-management-side-panel-filters',
    EnableLocalLongTermSubmittalShift = 'enable-local-long-term-submittal-shift'
}
